import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../context/AuthContext";

const Users = () => {
  const { user } = useContext(AuthContext);

  const [users, setUsers] = useState([]);
  const [selected, setSelected] = useState([]);

  // ======================
  // ROLES
  // ======================
  const isAdmin = user?.role_id === 3;
  const isIKT = user?.role_id === 2;
  const isUser = user?.role_id === 1;

  const canDelete = isAdmin;
  const canViewPage = isAdmin || isIKT || isUser;

  const selectedUsers = users.filter((u) => selected.includes(u.id));

  const actionType = selectedUsers.length
    ? selectedUsers[0].is_active == 1
      ? "deactivate"
      : "activate"
    : null;

  // ======================
  // FETCH USERS
  // ======================
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/getUser.php`)
      .then((res) => res.json())
      .then((data) => setUsers(data))
      .catch((err) => console.error("Error loading users:", err));
  }, []);

  if (!canViewPage) {
    return (
      <div className="p-10 text-center text-red-500 font-bold">
        Nimaš dostopa do Users strani
      </div>
    );
  }

  // ======================
  // SELECT LOGIC
  // ======================
  const toggleSelect = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
    );
  };

  const toggleAll = () => {
    if (selected.length === users.length) {
      setSelected([]);
    } else {
      setSelected(users.map((u) => u.id));
    }
  };

  // ======================
  // DELETE USERS (ADMIN ONLY)
  // ======================
  const toggleUsers = async () => {
    if (selected.length === 0) return;

    const endpoint =
      actionType === "activate"
        ? `${process.env.REACT_APP_API_URL}/activateUsers.php`
        : `${process.env.REACT_APP_API_URL}/deactivateUsers.php`;

    try {
      const res = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ ids: selected.map(Number) }),
      });

      const result = await res.json();
      console.log(users);
      console.log("RESULT:", result);

      if (result.success) {
        setUsers((prev) =>
          prev.map((u) =>
            selected.includes(u.id)
              ? { ...u, is_active: actionType === "activate" ? 1 : 0 }
              : u,
          ),
        );

        setSelected([]);
      } else {
        alert("Operation failed");
      }
    } catch (err) {
      console.error(err);
      alert("Server error");
    }
  };
  // ======================
  // UI
  // ======================
  return (
    <div className="bg-gray-50 p-5 m-2 rounded-2xl">
      <h1 className="text-3xl font-bold mb-5">Uporabniki</h1>

      {/* DELETE BUTTON (ADMIN ONLY) */}
      {selected.length > 0 && actionType !== "mixed" && (
        <button
          onClick={toggleUsers}
          className={`text-white px-4 py-2 rounded mb-4 ${
            actionType === "activate" ? "bg-green-600" : "bg-midBlue"
          }`}
        >
          {actionType === "activate"
            ? `Activate selected (${selected.length})`
            : `Deactivate selected (${selected.length})`}
        </button>
      )}

      {/* TABLE */}
      <div className="hidden md:block bg-white rounded-2xl shadow overflow-auto">
        <table className="w-full text-sm">
          <thead className="bg-gray-100 text-left">
            <tr>
              {/* CHECKBOX HEADER (ADMIN ONLY) */}
              {isAdmin && (
                <th className="p-4">
                  <input
                    type="checkbox"
                    className="accent-midBlue w-4 h-4 cursor-pointer"
                    checked={
                      selected.length === users.length && users.length > 0
                    }
                    onChange={toggleAll}
                  />
                </th>
              )}

              <th className="p-4">Ime</th>
              <th className="p-4">Priimek</th>
              <th className="p-4">Email</th>
              <th className="p-4">Vloga</th>
              <th className="p-4">Verified</th>
              <th className="p-4">Status</th>
            </tr>
          </thead>

          <tbody>
            {users.map((u) => (
              <tr key={u.id} className="border-t">
                {/* ROW CHECKBOX (ADMIN ONLY) */}
                {isAdmin && (
                  <td className="p-4">
                    <input
                      type="checkbox"
                      className="accent-midBlue w-4 h-4 cursor-pointer"
                      checked={selected.includes(u.id)}
                      onChange={() => toggleSelect(u.id)}
                    />
                  </td>
                )}

                <td className="p-4">{u.name}</td>
                <td className="p-4">{u.surname}</td>
                <td className="p-4">{u.email}</td>
                <td className="p-4">{u.role}</td>

                {/* VERIFIED STATUS */}
                <td className="p-4">
                  {u.is_verified ? (
                    <span className="text-green-600 font-semibold">Da</span>
                  ) : (
                    <span className="text-red-500 font-semibold">Ne</span>
                  )}
                </td>
                {/* ACTIVE STATUS */}
                <td className="p-4">
                  {Number(u.is_active) === 1 ? (
                    <span className="text-primary font-semibold">Active</span>
                  ) : (
                    <span className="text-lightAccent font-semibold">
                      Inactive
                    </span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* MOBILE */}
      <div className="md:hidden space-y-3">
        {users.map((u) => (
          <div key={u.id} className="bg-white rounded-2xl shadow p-4 border">
            <div className="flex justify-between items-start mb-3">
              <div>
                <p className="font-bold text-lg">
                  {u.name} {u.surname}
                </p>
                <p className="text-sm text-gray-500">{u.email}</p>
              </div>

              {/* MOBILE CHECKBOX (ADMIN ONLY) */}
              {isAdmin && (
                <input
                  type="checkbox"
                  className="accent-midBlue w-4 h-4 cursor-pointer"
                  checked={selected.includes(u.id)}
                  onChange={() => toggleSelect(u.id)}
                />
              )}
            </div>

            <div className="text-sm space-y-1">
              <p>
                <span className="font-semibold">Vloga:</span> {u.role}
              </p>

              <p>
                <span className="font-semibold">Verified:</span>{" "}
                {u.is_verified ? (
                  <span className="text-green-600 font-semibold">Da</span>
                ) : (
                  <span className="text-red-500 font-semibold">Ne</span>
                )}
              </p>
              <p>
                <span className="font-semibold">Status:</span>{" "}
                {Number(u.is_active) === 1 ? (
                  <span className="text-darkPrimary font-semibold">Active</span>
                ) : (
                  <span className="text-midBlue font-semibold">Inactive</span>
                )}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Users;
